import { ChangeEvent, useEffect } from "react";
import { MESSAGE } from '../../../utils/message';
import { Row, Col, Image, Form, Button } from "react-bootstrap";
import {
  ManageAccountSection,
  ManageAccountTitle,
  AccountBlue,
  AccountText,
  AccountEdit,
  ImageUpload,
  FileIcon,
  CustomRadioBox,
  FromButton,
} from './manageAccountStyle';
import FileUploadIcon from '../../../assests/images/linear-edit.svg';
import NoImage from "../../../assests/images/gnp_noimg.png";
import { useDispatch, useSelector } from "react-redux";
import { accountDetailHandler } from "../../../redux/slices/myAccount/accountDetail-slice";
import { REGEX } from "../../../utils/constant";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateAccDetailHandler } from "../../../redux/slices/myAccount/updateAccDetail-slice";
import { ManageAccountFormikProps } from "../../../utils/types";
import { useNavigate } from "react-router-dom";
import { setProfileUpdateStatus } from "../../../redux/slices/myAccount/profileUpdated-slice";
import { sendEmailForVerification } from "../../../redux/slices/myAccount/sendVerificationMail";

const ManageAccountTab = ({ setKey }: any) => {
  const user_id: string | null = typeof localStorage !== "undefined" && localStorage.getItem("userId")
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const accountDetail = useSelector((state: any) => state?.accountDetail);


  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      formik.setFieldValue(e.target.id, e.target.files[0]);
    }
  };
  const handleSendMail = () => {
    const userId = accountDetail?.data?.user_id
    const domain = window.location.origin;

    if (accountDetail) {
      dispatch(sendEmailForVerification({ email: accountDetail?.data?.email, link: `${domain}/verify_email/${userId}/` }))
    }
  }



  useEffect(() => {
    if (user_id) {
      dispatch(accountDetailHandler(user_id));
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      screen_name: accountDetail?.data?.screen_name || "",
      email: accountDetail?.data?.email || "",
      password: "",
      confirmPassword: "",
      email_opt_marketing: Boolean(accountDetail?.data?.email_opt_marketing),
      email_opt_message: Boolean(accountDetail?.data?.email_opt_message),
      profile_picture: accountDetail?.data?.profile_picture || "",
    },
    enableReinitialize: false,
    validationSchema: Yup.object({
      screen_name: Yup.string().trim().required(MESSAGE.requiredErrors("Screen Name")),
      email: Yup.string().trim().required(MESSAGE.requiredErrors("Email")).matches(REGEX.emailValidate, "Invalid Email Address"),
      password: Yup.string().trim()
        .matches(
          REGEX.passwordValidate,
          "Password must contain a special character, uppercase letter, number, and be at least 8 characters long"
        ),
      // confirmPassword: Yup.string().trim().required(MESSAGE.requiredErrors("Confirm Password"))
      //   .oneOf([Yup.ref("password")], "Password does not Match"),
      confirmPassword: Yup.string()
        .trim()
        .when("password", {
          is: (password: string) => !!password, // Ensures that `password` exists and is not empty
          then: (schema) =>
            schema
              .required(MESSAGE.requiredErrors("Confirm Password"))
              .oneOf([Yup.ref("password")], "Password does not Match"),
          otherwise: (schema) => schema,
        }),
      profile_picture: Yup.string(),
    }),
    onSubmit: async (values: ManageAccountFormikProps) => {
      const formData = new FormData();
      formData.append("screen_name", values.screen_name);
      formData.append("email", values.email);
      if (values.password) {
        formData.append("password", values.password);
      }
      if (values.confirmPassword) {
        formData.append("confirmPassword", values.confirmPassword);
      }
      formData.append("email_opt_marketing", values.email_opt_marketing ? "1" : "0");
      formData.append("email_opt_message", values.email_opt_message ? "1" : "0");

      if (typeof values.profile_picture === "object") {
        formData.append("profile_picture", values.profile_picture);
      }
      await dispatch(updateAccDetailHandler(user_id as string, formData))


      // await dispatch(updateAccDetailHandler(user_id as string, formData));
      await dispatch(setProfileUpdateStatus("updated"));
      dispatch(accountDetailHandler(user_id as string));
    },

  });
  return (
    <ManageAccountSection>
      <ManageAccountTitle> {MESSAGE.manageAccount}</ManageAccountTitle>
      {accountDetail?.data?.email_verified !== true && <AccountBlue>
        <AccountText>You must verify your email address in order to be able to receive email from GreatNonprofits.
        </AccountText>
        <Button onClick={(e) => { e.preventDefault(); handleSendMail() }} className="btn bg-transparent border-0 p-0 m-0 outline-none"
          onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
          onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
        >Re-send verification email</Button>
      </AccountBlue>}
      <AccountEdit>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col sm={12} md={12} lg={3}>
              <Form.Group className="profile-upload">
                <label htmlFor="profile_picture" className="add-photo">
                  <FileIcon><Image src={FileUploadIcon} /></FileIcon></label>
                <Form.Control className="upload-img" id="profile_picture" type="file" onChange={handleFileChange} />
                <ImageUpload>
                  {typeof formik.values.profile_picture === "object" ? (
                    <Image src={URL.createObjectURL(formik.values.profile_picture)} alt="Uploaded Preview" />
                  ) : formik.values.profile_picture ? (
                    <Image src={formik.values.profile_picture} alt="Profile Image" />
                  ) : (
                    <Image src={NoImage} alt="Placeholder Image" />
                  )}
                </ImageUpload>

              </Form.Group>
            </Col>

            <Col sm={12} md={12} lg={9} className="profile-form-section">
              <Row>
                <Col sm={12} md={6} lg={6}>
                  <Form.Group className="input-box">
                    <Form.Label>Screen Name</Form.Label>
                    <Form.Control type="text" placeholder="Your name" name="screen_name" value={formik.values.screen_name} onChange={formik.handleChange} />
                    {formik.touched.screen_name && formik.errors.screen_name && (
                      <div className="error">
                        {typeof formik.errors.screen_name === 'string' && <p>{formik.errors.screen_name}</p>}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col sm={12} md={6} lg={6}>
                  <Form.Group className="input-box-two">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email" placeholder="steve.riley@mail.com" name="email" value={formik.values.email} onChange={formik.handleChange} readOnly />
                    {formik.touched.email && formik.errors.email && (
                      <div className="error email-error">
                        {typeof formik.errors.email === 'string' && <p>{formik.errors.email}</p>}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col sm={12} md={6} lg={6}>
                  <Form.Group className="input-box">
                    <Form.Label>Change Password</Form.Label>
                    <Form.Control type="password" placeholder="******" name="password" maxLength={30} value={formik.values.password} onChange={formik.handleChange} />
                    {formik.touched.password && formik.errors.password && (
                      <div className="error">
                        {typeof formik.errors.password === 'string' && <p>{formik.errors.password}</p>}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <Col sm={12} md={6} lg={6}>
                  <Form.Group className="input-box">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control type="password" placeholder="******" name="confirmPassword" maxLength={30} value={formik.values.confirmPassword} onChange={formik.handleChange} />
                    {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                      <div className="error">
                        {typeof formik.errors.confirmPassword === 'string' && <p>{formik.errors.confirmPassword}</p>}
                      </div>
                    )}
                  </Form.Group>
                </Col>
                <CustomRadioBox>
                  <Form.Check aria-label="radio 1" id="email_opt_marketing" name="email_opt_marketing" checked={!!formik.values.email_opt_marketing} onChange={formik.handleChange} />
                  <label htmlFor='email_opt_marketing' className='form-check-label'>Send me updates about GreatNonprofits I've added to my favorites.</label>
                </CustomRadioBox>

                <CustomRadioBox>
                  <Form.Check aria-label="radio 2" id="email_opt_message" name="email_opt_message" checked={!!formik.values.email_opt_message} onChange={formik.handleChange} />
                  <label htmlFor='email_opt_message' className='form-check-label'>Send me comments/messages from other users about my reviews.</label>
                </CustomRadioBox>

                <FromButton className="manage-account-button">
                  <Button className="btn-outline-success-blue" type="submit">Save Change{accountDetail?.isLoading && <span className="btnloader"></span>}</Button>
                  <Button className="btn-outline" onClick={() => { setKey("reviews"); navigate(`/users/profile/${user_id}`) }}>Cancel</Button>
                </FromButton>

              </Row>
            </Col>
          </Row>
        </Form>
      </AccountEdit>
    </ManageAccountSection>
  );
};

export default ManageAccountTab;
